<template>
  <div class="media-section">
    <div class="container">
      <div class="section-title">
        <h2>Media</h2>
        <div class="text">
          <p>
            To request information, interviews, or images, please call
            <a href="https://www.k-linepr.com/" target="_blank"
              >K-Line Media Group</a
            >
            at
            <a class="c-link" href="tel:9493155101" target="_blank"
              >949-315-5101</a
            >. We will help provide information and images for your
            story.
          </p>
        </div>
      </div>
      <div class="media-list">
        <media-box 
          :title="'Built In Colorado'"
          :link="'https://www.builtincolorado.com/2020/10/26/colorado-tech-news-102620'"
          imageSource="media-img-1.jpg" >
          <p>
            <b>SharedCharter offers private flight rideshare.</b> Its
            peer-to-peer network simplifies the process of sharing and
            booking private charter flights. Having greater access to
            private flights is especially relevant due to the pandemic.
          </p>
        </media-box>

        <media-box 
          title='Skies Magazine'
          link='https://www.skiesmag.com/news/sharedcharter-shakes-up-flight-sharing-marke'
          imageSource="media-img-2.jpg" >
          <p>
                One of the most powerful qualities of the internet is how it
                brings people together. Airbnb unites vacation property owners
                with travelers, and Uber brings passengers together with
                drivers. A quick search on a smartphone connects us to just
                about any product or service provider in seconds, and we’re all
                doing it.
              </p>
              <p>
                To long-time pilot Carl Marbach, it makes sense to digitally
                link people for private jet travel, too. He is the founder and
                CEO of Boca Raton, Fla.-based SharedCharter, a new online
                service that connects business aviation users so they can share
                a flight while also splitting the costs.
              </p>
        </media-box>

        <media-box 
          title='Private Jet Card'
          link='https://www.skiesmag.com/news/sharedcharter-shakes-up-flight-sharing-marke'
          imageSource="media-img-3.jpg" >
          <p>
                While most press releases about private jet websites and apps
                that cross our desk brag about technology, interfaces, and
                algorithms designed to cut the mass of phone calls and emails
                typical of on-demand charter bookings,
                <a href="https://sharedcharter.com/" target="_blank"
                  >Sharedcharter.com</a
                >
                is offering a personalized approach.
              </p>
              <h4>Co-founder of Avweb</h4>
              <p>
                Former
                <a href="https://www.avweb.com/" target="_blank">Avweb</a>
                co-founder and owner Carl Marbach has launched the website as a
                searchable bulletin board for members to post and review
                possible shared flights. Membership is free but is necessary to
                comply with FAA regulations that govern aggregating Part 135
                flights.
              </p>
              <p>
                Once you join, you can enter the from and to part of your
                request, plus an acceptable date range, which can be as specific
                as a morning or afternoon or range for months.
              </p>
        </media-box>
        
        <media-box 
          title='Forbes'
          link='https://www.forbes.com/sites/douggollan/2020/10/26/sharedchartercom-is-using-the-human-touch-to-make-private-jet-flights-affordable/?sh=7ef5d06a4bdb'
          imageSource="media-img-4.jpg" >
          <p>
                Most new private jet booking platforms boast about technology
                and algorithms designed to streamline the archaic private jet
                charter booking process. The idea is to cut down on the numerous
                phone calls and emails. That's not the case with&nbsp;<a
                  class="color-link"
                  title="https://sharedcharter.com/"
                  href="https://sharedcharter.com/"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  data-ga-track="ExternalLink:https://sharedcharter.com/"
                  aria-label="Sharedcharter.com"
                  >Sharedcharter.com</a
                >, a new website founded by an industry veteran.
              </p>
              <p>
                Carl Marbach has owned seven airplanes, including one he built.
                In 1996, he co-founded Avweb.com, one of the Internet's first
                aviation magazines wholly online. Now, he's back and is hoping
                to conquer a space that, so far, several of the industry's
                largest players have struggled with.
              </p>
        </media-box>

        <media-box 
          title='Yahoo Finance'
          link='https://finance.yahoo.com/news/flight-sharing-startup-creating-space-142000190.html'
          imageSource="media-img-5.png" >
                        <p>
                The popular ridesharing concept is quickly gaining traction in
                the charter air travel market.&nbsp;<b
                  ><a
                    class="link rapid-noclick-resp"
                    href="https://c212.net/c/link/?t=0&amp;l=en&amp;o=2956386-1&amp;h=200830104&amp;u=https%3A%2F%2Fsharedcharter.com%2F&amp;a=SharedCharter"
                    target="_blank"
                    rel="nofollow noopener"
                    data-ylk="slk:SharedCharter"
                    data-rapid_p="6"
                    data-v9y="1"
                    >SharedCharter</a
                  ></b
                >
                is a new online service that offers more passengers access to
                the luxury of flying private through their proprietary
                peer-to-peer network that simplifies the process of sharing and
                booking private charter flights.
              </p>
              <p>
                SharedCharter's smart database is the industry's first
                peer-to-peer flight-sharing network for flying private for less.
              </p>

        </media-box>
        
        <media-box 
          title='Aviation International News'
          link='https://www.ainonline.com/aviation-news/business-aviation/2020-10-14/startup-platform-arranges-shared-charter-flights'
          imageSource="media-img-6.png" >
          <p>
                Veteran pilot Carl Marbach has launched SharedCharter, a
                Web-based platform for connecting people to book and share
                private charter flights in the U.S.
              </p>
              <p>
                The platform—which earns a commission on each trip from either
                the operator or broker—allows people to search for a charter
                flight or sign up for a free membership and propose a new,
                shared flight. Once two parties match a flight, SharedCharter
                provides secure and anonymous communication between them to
                discuss trip specifics. Once the parties agree on the specifics,
                SharedCharter also will provide a concierge to manage flight
                arrangements with Part 135 operators and charter brokers.
              </p>
        </media-box>

        <media-box 
          title='TravelDailyNews International'
          link='https://www.traveldailynews.com/post/flight-sharing-startup-creating-space-for-more-travelers-to-fly-private'
          imageSource="media-img-7.png" >
          <p>
                The popular ridesharing concept is quickly gaining traction in
                the charter air travel
                market.&nbsp;<strong>SharedCharter</strong>&nbsp;is a new online
                service that offers more passengers access to the luxury of
                flying private through their proprietary peer-to-peer network
                that simplifies the process of sharing and booking private
                charter flights.
              </p>
              <p>
                <em
                  >“When charter flights fill empty seats, typically the price
                  of the flight goes down for all the travelers,”</em
                >&nbsp;says<strong>&nbsp;Carl Marbach</strong>, President and
                CEO of SharedCharter, and veteran pilot.&nbsp;<em
                  >“I realized there was a need for a hub where people could
                  easily find others to share their desired flights, and at the
                  same time, significantly reduce the price of the flight versus
                  chartering the plane on their own.”</em
                >
              </p>
        </media-box>

        <media-box 
          title='Corporate Jet Investor'
          link='https://www.traveldailynews.com/post/flight-sharing-startup-creating-space-for-more-travelers-to-fly-private'
          imageSource="media-img-8.png">
          <p>
                SharedCharter is a new online service that offers more
                passengers access to the luxury of flying private through their
                proprietary peer-to-peer network that simplifies the process of
                sharing and booking private charter flights.
              </p>
              <p>
                The process starts at SharedCharter.com where passengers can
                search the network for existing flights or sign up for a no-cost
                membership to initiate a new itinerary or join an existing trip.
              </p>
        </media-box>

        <media-box 
          title='Skies Magazine'
          link='https://www.skiesmag.com/press-releases/flight-sharing-startup-creating-space-for-more-travellers-to-fly-private/'
          imageSource="media-img-9.png" >
           <p>
                The popular ridesharing concept is quickly gaining traction in
                the charter air travel market. SharedCharter is a new online
                service that offers more passengers access to the luxury of
                flying private through their proprietary peer-to-peer network
                that simplifies the process of sharing and booking private
                charter flights.
              </p>
              <p>
                The company’s model intends to make flying private accessible to
                a whole new audience interested in upgrading their experience
                with its numerous advantages, including private concierge
                service, no TSA screening lines, custom food and beverage, bag
                retrieval in minutes, and door to destination travel time cut by
                hours.
              </p>
        </media-box>

        <media-box
          title='Global Travel Media'
          link='https://www.eglobaltravelmedia.com.au/flight-sharing-startup-creating-space-for-more-travelers-to-fly-private/'
          imageSource="media-img-10.png" >
          <p>
                The popular ridesharing concept is quickly gaining traction in
                the charter air travel market. SharedCharter is a new online
                service that offers more passengers access to the luxury of
                flying private through their proprietary peer-to-peer network
                that simplifies the process of sharing and booking private
                charter flights.
              </p>
              <p>
                SharedCharter is also addressing the headwinds of commercial
                flying in this era of escalating public health concerns. The
                ability to fly private during this time of Covid-19 is arguably
                safer than flying commercial airlines with thousands of people
                at large airports and hundreds of people crammed into a plane.
                Fewer people, less spread.
              </p>
        </media-box>

        <media-box
          title='Veranda'
          link='https://www.veranda.com/travel/a34634977/2021-travel-trends/'
          imageSource="media-img-11.png" >
          <p>
                The popular ridesharing concept is quickly gaining traction in
                the charter air travel market. SharedCharter is a new online
                service that offers more passengers access to the luxury of
                flying private through their proprietary peer-to-peer network
                that simplifies the process of sharing and booking private
                charter flights.
              </p>
              <p>
                SharedCharter is also addressing the headwinds of commercial
                flying in this era of escalating public health concerns. The
                ability to fly private during this time of Covid-19 is arguably
                safer than flying commercial airlines with thousands of people
                at large airports and hundreds of people crammed into a plane.
                Fewer people, less spread.
              </p>
        </media-box>

        <media-box
          title='Corporate Jet Investor'
          link='https://www.corporatejetinvestor.com/articles/sharedcharter-creating-a-niche-in-business-aviation-229/'
          imageSource="media-img-12.png" >
          <p>
            SharedCharter is a new company in business aviation founded by
            veteran pilot, Carl Marbach. He says SharedCharter has “created
            a new ‘people-first’ niche that matches travellers at the onset
            of planning and fills empty seats after.”
          </p>
          <p>
            The company’s model allows potential flyers to find other
            travellers to share flights, and once a match is made, they
            source the best aircraft for the trip and then facilitate all
            amenities expected when flying private.
          </p>
        </media-box>

        <media-box
          title='Travel Daily News'
          link='https://www.traveldailynews.com/post/sharedcharter-carves-out-new-people-first-niche-in-private-jet-charter-marketplace'
          imageSource="media-img-13.png" >
          <p>
                BOCA RATON, FL - Competition in today’s private jet charter
                marketplace has significantly risen since the onset of COVID and
                many new companies are vying for a share of this highly desired
                consumer market.
              </p>
              <p>
                The hottest trend, flight-sharing led by Florida-based
                <strong>SharedCharter</strong>, is upending established business
                models that until now have fallen into these categories: air
                charter open marketplaces, operator direct-to-consumer,
                membership programs and fractional ownerships.
              </p>
        </media-box>

        <media-box
          title='AIN Online'
          link='https://www.ainonline.com/aviation-news/business-aviation/2021-03-22/company-puts-people-first-shared-charters'
          imageSource="media-img-14.png" >
          <p>
                A new Boca Raton, Florida-based company led by AvWeb co-founder
                Carl Marbach aims to make the sharing of charter flights easier
                and without filling an existing booked airplane or membership.
                Called SharedCharter, the company is employing a “people first”
                process that matches up travelers at the onset of the planning
                process and fills any remaining empty seats afterwards.
              </p>
              <p>
                SharedCharter’s model allows potential flyers to find other
                travelers to share desired flights, and once a match is made,
                they source the appropriate aircraft for the trip from a
                pre-qualified network of private jet brokers and Part 135
                operators. Travelers are not limited by aircraft or location, it
                added.
              </p>
        </media-box>

      </div>
    </div>
  </div>
</template>

<script>
import MediaBox from './List/Box'

export default {
  name: 'Media',
  metaInfo: {
            title: 'Media | Shared Charter',
            meta: [
                {
                    name: 'description',
                    content: 'Media To request information, interviews, or images, please call K-Line Media Group at 949-315-5101. We will help provide information and images for your story. Built In Colorado SharedCharter offers private flight rideshare. Its peer-to-peer network simplifies the process of sharing and booking private charter flights.'
                },
            ]
        },
  components:{MediaBox}
}
</script>


<style scoped>
/* MEDIA PAGE */

/* MEDIA SECTION */
.media-section {
  padding: 50px 0;
}
.media-section .container {
  max-width: 1440px;
}
.media-section .section-title .text p {
  margin: 40px 0;
}
.media-section .media-box {
  display: flex;
  margin-bottom: 70px;
}
.media-section .media-box:last-child {
  margin-bottom: 0;
}
.media-section .media-box .image {
  width: 450px;
}
.media-section .media-box .image a {
  display: inline-block;
  vertical-align: top;
  width: 100%;
}
.media-section .media-box .content {
  width: calc(100% - 450px);
  padding-left: 40px;
}
.media-section .media-box .content .text {
  margin: 40px 0;
}
.media-section .media-box .content .text h4 {
  margin-bottom: 15px;
}
.media-section .media-box .dark-blue-btn a {
  min-width: 200px;
}
@media (max-width: 991px) {
  .media-section .media-box .image {
    width: 350px;
  }
  .media-section .media-box .content {
    width: calc(100% - 350px);
  }
  .media-section .media-box .content .text {
    margin: 20px 0;
  }
}

@media (max-width: 767px) {
  .media-section .section-title .text p {
    margin-top: 20px;
  }
  .media-section .media-box {
    display: block;
  }
  .media-section .media-box .content {
    width: 100%;
    padding: 30px 0 0;
  }
}

@media (max-width: 575px) {
  .media-section .media-box .image {
    width: 270px;
  }
}
</style>